import { CTA_MODE } from "@/config";
import { CtaButton } from "@/components/Cta";

const HERO_IMG =
  "https://images.unsplash.com/photo-1649886962584-f8c88b3bf918?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxiYXNlbWVudCUyMHBhcmtpbmclMjBnYXJhZ2UlMjBuaWdodCUyMGRhcmt8ZW58MHx8fHwxNzg5MDIxOTc3fDA&ixlib=rb-4.1.0&q=85&w=1600";

export const Hero = () => (
  <section data-testid="hero" className="relative overflow-hidden border-b border-line">
    <img
      src={HERO_IMG}
      alt="An empty private parking bay in a Bengaluru basement at night"
      width="1600"
      height="1067"
      className="absolute inset-0 h-full w-full object-cover opacity-[0.55]"
    />
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(100deg, rgba(5,9,20,0.95) 0%, rgba(5,9,20,0.82) 55%, rgba(5,9,20,0.6) 100%), linear-gradient(180deg, rgba(5,9,20,0.5) 0%, rgba(5,9,20,0.35) 40%, #050914 100%)",
      }}
      aria-hidden="true"
    />
    <div className="nb-shell relative pb-16 pt-[132px] sm:pb-28 sm:pt-[184px]">
      <p data-testid="hero-eyebrow" className="nb-eyebrow animate-nb-rise">
        Bengaluru · Monthly overnight parking
      </p>
      <h1
        data-testid="hero-h1"
        className="mt-5 max-w-[16ch] animate-nb-rise text-4xl sm:text-5xl lg:text-6xl"
        style={{ animationDelay: "80ms" }}
      >
        Your car sleeps somewhere safe tonight.
      </h1>
      <p
        data-testid="hero-sub"
        className="mt-6 max-w-[62ch] animate-nb-rise text-base text-ink2 sm:text-lg"
        style={{ animationDelay: "160ms" }}
      >
        NightBay rents private parking bays by the month — a real bay in a real building, 5 minutes
        from home, from <span className="nb-num">₹1,200</span> a month. Every bay is checked by a
        person before it ever shows up here.
      </p>
      <div
        className="mt-9 flex animate-nb-rise flex-col gap-3 sm:flex-row"
        style={{ animationDelay: "240ms" }}
      >
        <CtaButton side="renter" testId="hero-cta-renter">
          Find a spot near me
        </CtaButton>
        <CtaButton side="host" variant="ghost" testId="hero-cta-host">
          I have a bay to rent out
        </CtaButton>
      </div>
      {CTA_MODE === "lead" && (
        <p
          data-testid="hero-note"
          className="mt-6 max-w-[58ch] animate-nb-rise text-sm text-ink3"
          style={{ animationDelay: "320ms" }}
        >
          We're onboarding the first hosts and renters by hand. Leave your number and we'll call you
          within one working day — no app download needed yet.
        </p>
      )}
    </div>
  </section>
);
